/*
 * @Author: Zhouqi (Refactored by Claude v2)
 * @Date: 2025-11-08 15:23:48
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-04 11:00:58
 * @Description: FileUpload 统一导出
 */

// 统一的 FileUpload 组件（推荐使用）
export { default as FileUpload } from './BaseUpload';
export { default } from './BaseUpload';

// 统一常量和类型
export * from './config';
export * from './constants';
export * from './types';

// 通用工具和类型
export * from './common/constants';
export * from './common/types';
export * from './common/utils';
export * from './common/utils/timeUtils';
